import React from 'react';

import { IntlMsg } from '../_core/IntlMsg/intl-msg.component';
import { RSVP_STATUS_MESSAGES } from './attendance.messages';
import { RSVP_STYLES } from './attendance.helpers';

interface IRsvpBadgeProps {
  status: AttendanceStatus;
}

export const RsvpBadge: React.FC<IRsvpBadgeProps> = ({ status }) => {
  const style = RSVP_STYLES[status];
  const message = RSVP_STATUS_MESSAGES[status];

  return (
    <span
      role="status"
      aria-label={`RSVP: ${message.defaultMessage}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.375rem',
        whiteSpace: 'nowrap',
        fontSize: '0.875rem',
      }}
    >
      <span
        aria-hidden="true"
        style={{
          width: '0.625rem',
          height: '0.625rem',
          borderRadius: '50%',
          backgroundColor: style.color,
          display: 'inline-block',
        }}
      />
      <IntlMsg {...message} />
    </span>
  );
};

